import { render, staticRenderFns } from "./AttendancePolicyView.vue?vue&type=template&id=15249dd1&"
import script from "./AttendancePolicyView.vue?vue&type=script&lang=js&"
export * from "./AttendancePolicyView.vue?vue&type=script&lang=js&"
import style0 from "./AttendancePolicyView.vue?vue&type=style&index=0&id=15249dd1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports